import type { CSSProperties } from "react";

export const pendingApprovalsStyles: Record<string, CSSProperties> = {
  button: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "0px 14px",
    borderRadius: "8px",
    backgroundColor: "rgb(234, 242, 255)",
    fontWeight: 500,
    height: "32px",
    border: "none",
  },
  icon: {
    color: "#184461",
    marginTop: "2px",
    paddingLeft: "5px",
  },
  label: {
    margin: 0,
  },
  badge: {
    backgroundColor: "#ff4d4f",
  },
};

export const approvalDrawerHeaderStyles: Record<string, CSSProperties> = {
  iconWrapper: {
    backgroundColor: "rgb(234, 242, 255)",
    borderRadius: "6px",
    padding: "4px",
    display: "flex",
    marginTop: "6px",
  },
  icon: {
    fontSize: "14px",
    color: "#184461",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.2,
  },
  titleText: {
    fontSize: "20px",
    color: "#184461",
  },
};

export const approvalCardStyles: Record<string, CSSProperties> = {
  row: {
    display: "flex",
    marginBottom: 8,
  },
  rowLabel: {
    width: 140,
    color: "#8c8c8c",
  },
  rowValue: {
    color: "#000000",
    fontWeight: 400,
  },
  card: {
    borderRadius: 12,
    background: "#ffffff",
  },
  body: {
    padding: 16,
  },
  divider: {
    margin: "12px 0",
  },
  footer: {
    color: "#184461",
    // cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    gap: 6,
    fontWeight: 600,
  },
  footerText: {
    cursor: "pointer",
  },
};

export const approvalCollapseStyles: Record<string, CSSProperties> = {
  collapse: {
    background: "transparent",
  },
  panel: {
    borderRadius: 12,
    margin: 8,
    background: "transparent",
    border: "1px solid #f0f0f0",
    fontWeight: 600,
  },
  panelContent: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
};
